import React from 'react';

import { base } from 'app/get-help/utils/tree';

import Login from './Login';

import { NodeDefinition } from 'app/get-help/utils/tree/types';

type NodeOptions = {
  loggedIn: NodeDefinition;
  loggedInFree: NodeDefinition;
  loggedOut: NodeDefinition;
};

const login = (options: NodeOptions): NodeDefinition => {
  const node = base({
    id: 'login',
    isRequired: false,
    children: {
      loggedIn: options.loggedIn,
      loggedInFree: options.loggedInFree,
      loggedOut: options.loggedOut,
    },
    // always true so that next node always renders
    hasData: () => true,
    getNextNode: (_data, meta) => {
      // If a user on any of the following, they should see the "paid" categories:
      // - a paid plan
      // - a trial
      // - less than 14 days since trial ended
      if (meta.account_id && meta.isPaidEmailSupportEligible)
        return options.loggedIn;
      // If the user is on a free plan, show them the logged in "free" categories:
      if (meta.account_id) return options.loggedInFree;
      // Otherwise, show the logged out categories:
      return options.loggedOut;
    },
    render: () => {
      return <Login />;
    },
    // don't export
    export: () => null,
  });

  return node;
};

export default login;
